// @flow

import * as React from "react";
import { withRouter } from "react-router-dom";
import useInvertedNav from "../../hooks/useInvertedNav";

// import Breadcrumbs from "../molecules/Breadcrumbs";

import { ReactComponent as Triangle } from "../../../assets/images/shape-triangle.svg";
import { ReactComponent as Circle } from "../../../assets/images/shape-circle.svg";
import { ReactComponent as Ring } from "../../../assets/images/shape-ring-thick-fill.svg";
import Breadcrumbs from "../molecules/Breadcrumbs";
import BackButton from "../atoms/BackButton";
import { PrimaryNavPad } from "./PrimaryNav";

type PropsType = {
    heading: string,
    breadcrumbs?: any[],
    customClass?: string,
    backLink?: {
        url?: string,
        title?: string,
        target?: string,
    },
};

const HeroInner = ({ heading }: { heading: string }): React.Node => {
    return (
        <React.Fragment>
            <h1 className="hero-profile-page__heading">{heading}</h1>
        </React.Fragment>
    );
};

const HeroContent = (props: PropsType): React.Node => {
    const baseClassName = "hero-profile-page";
    const classes = [baseClassName];

    if (props.customClass) {
        classes.push(`${baseClassName}--${props.customClass}`);
    }

    // invert primary nav color
    useInvertedNav();

    React.useEffect(() => {
        // ensure scroll to top on account pages
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                left: 0,
                // behavior: "smooth",
            });
        }, 100);
    }, []);

    return (
        <div className={classes.join(" ")}>
            <div className="hero-profile-page__overlay">
                <PrimaryNavPad />
                <div className="container-fluid">
                    {/* Design elements */}
                    <Circle className="hero-profile-page__circle-small" />
                    <Ring className="hero-profile-page__ring" />
                    <Triangle className="hero-profile-page__triangle" />
                    <div className="hero-profile-page__diamond" />

                    <div className="hero-profile-page__row row">
                        <div className="hero-profile-page__col col-xs-12 col-md-offset-2 col-md-8">
                            {props.backLink ? (
                                <BackButton
                                    className="hero-profile-page__back"
                                    to={props.backLink.url}
                                    target={props.backLink.target}
                                >
                                    <span className="text">
                                        {props.backLink.title || "Back"}
                                    </span>
                                </BackButton>
                            ) : null}

                            {/* {props.breadcrumbs ? (
                                <Breadcrumbs
                                    breadcrumbs={props.breadcrumbs}
                                    customPageTitle={props.heading}
                                    colorInverted
                                />
                            ) : null} */}
                            <Breadcrumbs
                                breadcrumbs={
                                    props.breadcrumbs || props.customBreadcrumbs
                                }
                                prependBreadcrumbs={props.prependBreadcrumbs}
                                customPageTitle={
                                    !props.customBreadcrumbs
                                        ? props.heading
                                        : null
                                }
                                colorInverted
                            />

                            {props.heading ? (
                                <HeroInner heading={props.heading} />
                            ) : null}

                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
            <div className="hero-profile-page__inner hero-profile-page__inner--no-image">
                <div className="hero-profile-page__inner__gap" />
            </div>
        </div>
    );
};

export default withRouter(HeroContent);
